import styled from 'styled-components'

export const ModalContainer = styled.div`
  background-color: #fff;
  width: 100%;
  z-index: ${({ zIndex }) => zIndex};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
